import { module } from 'angular';
import Prism from 'prismjs';

Prism.languages.curl = {
	curl:      /\bcurl\b/,
	url:       /https?:[\w./:=?{}\-]*/,
	parameter: {
		pattern: /[\dA-Z[\]-_a-z]+ *(?==)/,
	},
	value:     [
		{
			pattern:    /(=)([\w.-]*)/,
			lookbehind: true,
		},
		{
			pattern: /(["'])(\\(?:\r\n|[\S\s])|(?!\1)[^\n\r\\])*\1/,
		},
		{
			pattern:    /(-u )([\w.{}-]*)/,
			lookbehind: true,
		},
	],
	option:    / *-[A-Za-z]*\b/,
};

const directive = () => ({
	restrict: 'A',
	/**
	 * @param {any} $scope
	 * @param {any} element
	 */
	link($scope, element) {
		element.ready(() => {
			Prism.highlightElement(element[0]);
		});
	},
});

export default module('app.highlight', [])
	.directive('highlight', directive)
	.name;
